import React, {useRef, useState} from 'react';
import goldCoin from '../assets/Images/currency/gold40.png'
import silverCoin from '../assets/Images/currency/silver40.png'
import bronzeCoin from '../assets/Images/currency/bronze40.png'
import { CheckIcon } from '@heroicons/react/solid';

const getCoinIcon = (type) => {
  if(type === 'gold') return goldCoin;
  if(type === 'silver') return silverCoin;
  if(type === 'bronze') return bronzeCoin;
}

const Currency = (props) => {
  const inputRef = useRef(null);
  const [coinNumber, setCoinNumber] = useState(props.value)
  const [dirty, setDirty] = useState(false)

  const confirm = () => {
    let value = Number(String(coinNumber).replace(/(\D)/gm, ""));
    if (isNaN(value) || coinNumber === '') value = props.min;
    if (value > props.max) value = props.max;
    if (value < props.min) value = props.min;
    setCoinNumber(value);
    setDirty(false);
    props.updateValue(value);
  };

  return (
    <div className="blockCoin">
      <img
        onClick={() => inputRef.current.focus()}
        className="coinIcon"
        src={getCoinIcon(props.type)}
        alt="coin"
      />
      <input
        ref={inputRef}
        value={coinNumber}
        type="number"
        min={0}
        max={999}
        onChange={(e) => {
          setCoinNumber(e.target.value);
          setDirty(true);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') confirm();
        }}
      />
      {dirty && (
        <button className='coinConfirmBtn' onClick={confirm}>
          <CheckIcon style={{ width: 14, height: 14 }} />
        </button>
      )}
    </div>
  );

}

export default Currency
